import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  TextField,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Chip,
  TablePagination,
  Card,
  CardContent,
  InputAdornment,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Divider,
} from '@mui/material';
import { hasWritePermission } from '../../utils/menuFilter';
import {
  Search,
  SwapHoriz,
  Receipt,
  Person,
  Home,
  AttachMoney,
  Business,
  CheckCircle,
  Warning,
} from '@mui/icons-material';

const ChangePlot = () => {
  const canWriteChangePlot = hasWritePermission('plot-booking.change-plot');
  const [searchForm, setSearchForm] = useState({
    siteName: '',
    sector: '',
    block: '',
    bookingId: '',
  });

  const [showBookingDetails, setShowBookingDetails] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [changePlotDialogOpen, setChangePlotDialogOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [newPlotForm, setNewPlotForm] = useState({
    newSiteName: '',
    newPlotNo: '',
    changeReason: ''
  });
  const [errors, setErrors] = useState({});
  const [searchLoading, setSearchLoading] = useState(false);
  const [changeLoading, setChangeLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  // Sample booking data - this would come from API
  const [bookingData] = useState([
    {
      id: 1,
      bookingId: 'BK001',
      plotBookingDate: '2025-10-01',
      plotNo: 'P101',
      siteName: 'Green Valley',
      branchName: 'Mumbai Branch',
      paymentPlan: 'EMI Plan',
      customer: 'John Doe',
      associate: 'Agent Smith',
      plotAmount: '₹15,00,000',
      paidAmount: '₹5,00,000',
      status: 'Booked',
    },
    {
      id: 2,
      bookingId: 'BK002',
      plotBookingDate: '2025-09-28',
      plotNo: 'P205',
      siteName: 'Hill View',
      branchName: 'Delhi Branch',
      paymentPlan: 'One Time',
      customer: 'Jane Wilson',
      associate: 'Agent Brown',
      plotAmount: '₹18,00,000',
      paidAmount: '₹18,00,000',
      status: 'Alloted',
    },
    {
      id: 3,
      bookingId: 'BK003',
      plotBookingDate: '2025-10-05',
      plotNo: 'P087',
      siteName: 'Green Valley',
      branchName: 'Mumbai Branch',
      paymentPlan: 'Quarterly',
      customer: 'Mike Johnson',
      associate: 'Agent Davis',
      plotAmount: '₹12,00,000',
      paidAmount: '₹3,00,000',
      status: 'Booked',
    },
    {
      id: 4,
      bookingId: 'BK004',
      plotBookingDate: '2025-09-15',
      plotNo: 'P321',
      siteName: 'Paradise Heights',
      branchName: 'Bangalore Branch',
      paymentPlan: 'Half Yearly',
      customer: 'Sarah Davis',
      associate: 'Agent Wilson',
      plotAmount: '₹20,00,000',
      paidAmount: '₹10,00,000',
      status: 'Booked',
    },
    {
      id: 5,
      bookingId: 'BK005',
      plotBookingDate: '2025-08-20',
      plotNo: 'P456',
      siteName: 'Royal Gardens',
      branchName: 'Chennai Branch',
      paymentPlan: 'EMI Plan',
      customer: 'Robert Chen',
      associate: 'Agent Taylor',
      plotAmount: '₹25,00,000',
      paidAmount: '₹25,00,000',
      status: 'Alloted',
    },
    {
      id: 6,
      bookingId: 'BK006',
      plotBookingDate: '2025-08-10',
      plotNo: 'P789',
      siteName: 'Green Valley',
      branchName: 'Mumbai Branch',
      paymentPlan: 'Monthly EMI',
      customer: 'David Kumar',
      associate: 'Agent Sharma',
      plotAmount: '₹16,50,000',
      paidAmount: '₹8,25,000',
      status: 'Booked',
    },
    {
      id: 7,
      bookingId: 'BK007',
      plotBookingDate: '2025-07-25',
      plotNo: 'P654',
      siteName: 'Hill View',
      branchName: 'Delhi Branch',
      paymentPlan: 'Annual',
      customer: 'Lisa Patel',
      associate: 'Agent Gupta',
      plotAmount: '₹22,00,000',
      paidAmount: '₹22,00,000',
      status: 'Alloted',
    },
    {
      id: 8,
      bookingId: 'BK008',
      plotBookingDate: '2025-07-15',
      plotNo: 'P432',
      siteName: 'Paradise Heights',
      branchName: 'Bangalore Branch',
      paymentPlan: 'Quarterly',
      customer: 'Raj Mehta',
      associate: 'Agent Singh',
      plotAmount: '₹19,75,000',
      paidAmount: '₹9,87,500',
      status: 'Booked',
    },
    {
      id: 9,
      bookingId: 'BK009',
      plotBookingDate: '2025-07-05',
      plotNo: 'P567',
      siteName: 'Royal Gardens',
      branchName: 'Chennai Branch',
      paymentPlan: 'One Time',
      customer: 'Priya Joshi',
      associate: 'Agent Reddy',
      plotAmount: '₹28,00,000',
      paidAmount: '₹28,00,000',
      status: 'Alloted',
    },
    {
      id: 10,
      bookingId: 'BK010',
      plotBookingDate: '2025-06-30',
      plotNo: 'P890',
      siteName: 'Green Valley',
      branchName: 'Mumbai Branch',
      paymentPlan: 'EMI Plan',
      customer: 'Amit Verma',
      associate: 'Agent Kapoor',
      plotAmount: '₹14,25,000',
      paidAmount: '₹7,12,500',
      status: 'Booked',
    },
    {
      id: 11,
      bookingId: 'BK011',
      plotBookingDate: '2025-06-20',
      plotNo: 'P123',
      siteName: 'Hill View',
      branchName: 'Delhi Branch',
      paymentPlan: 'Half Yearly',
      customer: 'Sneha Agarwal',
      associate: 'Agent Mishra',
      plotAmount: '₹21,50,000',
      paidAmount: '₹10,75,000',
      status: 'Booked',
    },
    {
      id: 12,
      bookingId: 'BK012',
      plotBookingDate: '2025-06-10',
      plotNo: 'P345',
      siteName: 'Paradise Heights',
      branchName: 'Bangalore Branch',
      paymentPlan: 'One Time',
      customer: 'Vikram Shah',
      associate: 'Agent Nair',
      plotAmount: '₹26,00,000',
      paidAmount: '₹26,00,000',
      status: 'Alloted',
    },
  ]);

  // Sample dropdown options
  const siteOptions = ['Green Valley', 'Hill View', 'Paradise Heights', 'Royal Gardens'];
  const sectorOptions = ['Sector A', 'Sector B', 'Sector C', 'Sector D'];
  const blockOptions = ['Block 1', 'Block 2', 'Block 3', 'Block 4'];

  const handleInputChange = (field, value) => {
    setSearchForm({
      ...searchForm,
      [field]: value,
    });
    // Clear errors when user starts typing
    if (errors[field]) {
      setErrors({ ...errors, [field]: '' });
    }
  };

  const handleSearch = async () => {
    setSearchLoading(true);
    setErrors({});

    // Simulate API call
    setTimeout(() => {
      setShowBookingDetails(true);
      setPage(0); // Reset to first page when searching
      console.log('Searching with criteria:', searchForm);
      setSearchLoading(false);
    }, 1500);
  };

  const handleChangePlot = (booking) => {
    setSelectedBooking(booking);
    setChangePlotDialogOpen(true);
  };

  const handleCloseChangePlotDialog = () => {
    setChangePlotDialogOpen(false);
    setSelectedBooking(null);
    setNewPlotForm({
      newSiteName: '',
      newPlotNo: '',
      changeReason: ''
    });
    setErrors({});
  };

  const handleNewPlotFormChange = (e) => {
    const { name, value } = e.target;
    setNewPlotForm({ ...newPlotForm, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const validateChangePlotForm = () => {
    const newErrors = {};

    if (!newPlotForm.newSiteName.trim()) {
      newErrors.newSiteName = 'New site name is required';
    }

    if (!newPlotForm.newPlotNo.trim()) {
      newErrors.newPlotNo = 'New plot number is required';
    }

    if (!newPlotForm.changeReason.trim()) {
      newErrors.changeReason = 'Change reason is required';
    }

    return newErrors;
  };

  const handleConfirmChangePlot = async () => {
    const validationErrors = validateChangePlotForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setChangeLoading(true);

    // Simulate API call
    setTimeout(() => {
      setSuccessMessage(`Plot changed from ${selectedBooking.plotNo} to ${newPlotForm.newPlotNo} for booking ${selectedBooking.bookingId}`);
      setChangePlotDialogOpen(false);
      setNewPlotForm({
        newSiteName: '',
        newPlotNo: '',
        changeReason: ''
      });
      setSelectedBooking(null);
      setErrors({});
      console.log('Changed plot:', {
        fromBooking: selectedBooking,
        toPlot: newPlotForm
      });
      setChangeLoading(false);
    }, 2000);
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  // Enhanced filter function for booking data
  const getFilteredBookingData = () => {
    if (!showBookingDetails) return [];

    // If no search criteria provided, show all bookings
    const hasSearchCriteria = searchForm.bookingId.trim() ||
      searchForm.siteName ||
      searchForm.sector ||
      searchForm.block;

    if (!hasSearchCriteria) {
      return bookingData; // Show all bookings
    }

    return bookingData.filter(booking => {
      let matches = true;

      // Filter by Booking ID (partial match)
      if (searchForm.bookingId && searchForm.bookingId.trim()) {
        matches = matches && booking.bookingId.toLowerCase().includes(searchForm.bookingId.toLowerCase().trim());
      }

      // Filter by Site Name
      if (searchForm.siteName) {
        matches = matches && booking.siteName === searchForm.siteName;
      }

      // For demo purposes, we'll assume sector and block are part of plot details
      // In real implementation, you'd have this data in your booking records
      if (searchForm.sector) {
        // For demo, we'll show results if other criteria match
        // In real app, you'd filter by actual sector data
        matches = matches && true; // Replace with actual sector filtering
      }

      if (searchForm.block) {
        // For demo, we'll show results if other criteria match  
        // In real app, you'd filter by actual block data
        matches = matches && true; // Replace with actual block filtering
      }

      return matches;
    });
  };

  // Get search summary for display
  const getSearchSummary = () => {
    const criteria = [];
    if (searchForm.bookingId) criteria.push(`Booking ID: "${searchForm.bookingId}"`);
    if (searchForm.siteName) criteria.push(`Site: "${searchForm.siteName}"`);
    if (searchForm.sector) criteria.push(`Sector: "${searchForm.sector}"`);
    if (searchForm.block) criteria.push(`Block: "${searchForm.block}"`);

    return criteria.length > 0 ? criteria.join(', ') : 'All Bookings';
  };

  const handleClearSearch = () => {
    setSearchForm({
      siteName: '',
      sector: '',
      block: '',
      bookingId: '',
    });
    setShowBookingDetails(true); // Keep showing all bookings after clear
    setPage(0); // Reset to first page when clearing
  };

  const getStatusColor = (status) => {
    return status === 'Booked' ? 'error' : status === 'Alloted' ? 'primary' : 'default';
  };

  const getStatusStyle = (status) => {
    if (status === 'Booked') {
      return {
        backgroundColor: '#f44336',
        color: 'white',
      };
    } else if (status === 'Alloted') {
      return {
        backgroundColor: '#2196f3',
        color: 'white',
      };
    }
    return {};
  };

  // Calculate statistics
  const totalBookings = bookingData.length;
  const bookedCount = bookingData.filter(booking => booking.status === 'Booked').length;
  const allotedCount = bookingData.filter(booking => booking.status === 'Alloted').length;
  const totalAmount = bookingData.reduce((sum, booking) => {
    const amount = parseFloat(booking.plotAmount.replace(/[₹,]/g, ''));
    return sum + amount;
  }, 0);

  return (
    <Box sx={{ p: 3, backgroundColor: '#fafafa', minHeight: 'auto' }}>
      {/* Header Section */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#000', mb: 0.5 }}>
          Change Plot
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Search and change plot assignments for existing bookings
        </Typography>
      </Box>

      {successMessage && (
        <Alert severity="success" sx={{ mb: 4, borderRadius: 2 }}>
          <Box display="flex" alignItems="center" gap={1}>
            <CheckCircle />
            {successMessage}
          </Box>
        </Alert>
      )}

      {/* Summary Cards */}
      {/* <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2, height: '100%' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: '#e3f2fd',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Receipt sx={{ color: '#1976d2', fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700, color: '#000' }}>
                    {totalBookings}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total Bookings
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2, height: '100%' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: '#ffebee',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Warning sx={{ color: '#f44336', fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700, color: '#000' }}>
                    {bookedCount}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Booked Plots
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2, height: '100%' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: '#e8f5e9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <CheckCircle sx={{ color: '#2e7d32', fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700, color: '#000' }}>
                    {allotedCount}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Alloted Plots
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2, height: '100%' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: '#fff3e0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <AttachMoney sx={{ color: '#f57c00', fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700, color: '#000' }}>
                    ₹{(totalAmount / 100000).toFixed(1)}L
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total Value
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid> */}

      {/* Search Section */}
      <Card sx={{ mb: 4, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
        <CardContent sx={{ p: 4 }}>
          <Box display="flex" alignItems="center" gap={2} mb={3}>
            <Search sx={{ color: '#1976d2', fontSize: 28 }} />
            <Typography variant="h5" sx={{ fontWeight: 700, color: '#000' }}>
              Search Bookings for Plot Change
            </Typography>
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Site Name</InputLabel>
                <Select
                  value={searchForm.siteName}
                  label="Site Name"
                  onChange={(e) => handleInputChange('siteName', e.target.value)}
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="">Select Site</MenuItem>
                  {siteOptions.map((site) => (
                    <MenuItem key={site} value={site}>
                      {site}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Sector</InputLabel>
                <Select
                  value={searchForm.sector}
                  label="Sector"
                  onChange={(e) => handleInputChange('sector', e.target.value)}
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="">Select Sector</MenuItem>
                  {sectorOptions.map((sector) => (
                    <MenuItem key={sector} value={sector}>
                      {sector}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Block</InputLabel>
                <Select
                  value={searchForm.block}
                  label="Block"
                  onChange={(e) => handleInputChange('block', e.target.value)}
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="">Select Block</MenuItem>
                  {blockOptions.map((block) => (
                    <MenuItem key={block} value={block}>
                      {block}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Booking ID"
                value={searchForm.bookingId}
                onChange={(e) => handleInputChange('bookingId', e.target.value)}
                placeholder="Enter Booking ID"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Receipt color="action" />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSearch}
                  disabled={searchLoading}
                  startIcon={<Search />}
                  sx={{
                    px: 4,
                    py: 1.5,
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '15px',
                    boxShadow: '0 4px 12px rgba(83, 109, 254, 0.3)',
                    borderRadius: 2
                  }}
                >
                  {searchLoading ? 'Searching...' : 'Search Bookings'}
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClearSearch}
                  sx={{
                    px: 4,
                    py: 1.5,
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: 2
                  }}
                >
                  Clear & Show All
                </Button>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Booking Details Table */}
      {showBookingDetails && (
        <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
          <CardContent sx={{ p: 4 }}>
            <Box display="flex" alignItems="center" gap={2} mb={3}>
              <SwapHoriz sx={{ color: '#1976d2', fontSize: 28 }} />
              <Typography variant="h5" sx={{ fontWeight: 700, color: '#000' }}>
                Bookings Available for Plot Change
              </Typography>
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Search Criteria: {getSearchSummary()}
            </Typography>
            <Typography variant="body2" color="primary" sx={{ mb: 3, fontWeight: 600 }}>
              Found {getFilteredBookingData().length} booking(s) available for plot change
            </Typography>

            {getFilteredBookingData().length > 0 ? (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>S.No</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>Booking Info</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>Customer & Associate</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>Plot Details</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>Site & Branch</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>Financial Details</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>Status</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 700, fontSize: '14px', color: '#000' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getFilteredBookingData()
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((booking, index) => (
                        <TableRow
                          key={booking.id}
                          sx={{
                            '&:hover': { backgroundColor: '#f9fafb' },
                            '& td': { py: 2 }
                          }}
                        >
                          <TableCell sx={{ fontWeight: 600, color: '#000' }}>
                            {page * rowsPerPage + index + 1}
                          </TableCell>

                          <TableCell>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600, color: '#000' }}>
                                {booking.bookingId}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {booking.plotBookingDate}
                              </Typography>
                            </Box>
                          </TableCell>

                          <TableCell>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600, color: '#000' }}>
                                {booking.customer}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {booking.associate}
                              </Typography>
                            </Box>
                          </TableCell>

                          <TableCell>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600, color: '#000' }}>
                                Plot {booking.plotNo}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {booking.paymentPlan}
                              </Typography>
                            </Box>
                          </TableCell>

                          <TableCell>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600, color: '#000' }}>
                                {booking.siteName}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {booking.branchName}
                              </Typography>
                            </Box>
                          </TableCell>

                          <TableCell>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600, color: '#000' }}>
                                Total: {booking.plotAmount}
                              </Typography>
                              <Typography variant="caption" color="success.main">
                                Paid: {booking.paidAmount}
                              </Typography>
                            </Box>
                          </TableCell>

                          <TableCell>
                            <Chip
                              label={booking.status}
                              color={getStatusColor(booking.status)}
                              size="small"
                              sx={{ fontWeight: 600, fontSize: '12px' }}
                            />
                          </TableCell>

                          <TableCell align="center">
                            {/* {canWriteChangePlot && ( */}
                            <Tooltip title="Change Plot">
                              <IconButton
                                color="primary"
                                onClick={() => handleChangePlot(booking)}
                                sx={{
                                  '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.1)' }
                                }}
                              >
                                <SwapHoriz />
                              </IconButton>
                            </Tooltip>
                            {/* )} */}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>

                {/* Pagination */}
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  component="div"
                  count={getFilteredBookingData().length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{ borderTop: '1px solid #e0e0e0' }}
                />
              </TableContainer>
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Alert severity="info">
                  <Typography variant="h6" gutterBottom>
                    No Bookings Found
                  </Typography>
                  <Typography variant="body2">
                    No bookings match your search criteria: {getSearchSummary()}
                  </Typography>
                </Alert>
              </Box>
            )}
          </CardContent>
        </Card>
      )}

      {/* Change Plot Dialog */}
      <Dialog
        open={changePlotDialogOpen}
        onClose={handleCloseChangePlotDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2 }
        }}
      >
        <DialogTitle sx={{
          fontSize: '24px',
          fontWeight: 700,
          color: '#000',
          borderBottom: '1px solid #e0e0e0',
          pb: 2
        }}>
          <Box display="flex" alignItems="center" gap={2}>
            <SwapHoriz sx={{ color: '#1976d2', fontSize: 28 }} />
            Change Plot Assignment
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          {selectedBooking && (
            <Box>
              <Alert severity="info" sx={{ mb: 3, borderRadius: 2 }}>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  Change plot assignment for booking {selectedBooking.bookingId}
                </Typography>
              </Alert>

              {/* Current Booking Information */}
              <Card sx={{ p: 2, backgroundColor: '#f8f9fa', border: '1px solid #e9ecef', mb: 3 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1976d2' }}>
                  Current Plot Information
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">Booking ID</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {selectedBooking.bookingId}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">Current Plot</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {selectedBooking.plotNo}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">Customer</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {selectedBooking.customer}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">Current Site</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {selectedBooking.siteName}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">Plot Amount</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {selectedBooking.plotAmount}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">Booking Date</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {selectedBooking.plotBookingDate}
                    </Typography>
                  </Grid>
                </Grid>
              </Card>

              <Divider sx={{ my: 3 }}>
                <Typography variant="body2" color="text.secondary">New Plot Assignment</Typography>
              </Divider>

              {/* New Plot Form */}
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth error={!!errors.newSiteName}>
                    <InputLabel>New Site Name *</InputLabel>
                    <Select
                      name="newSiteName"
                      value={newPlotForm.newSiteName}
                      label="New Site Name *"
                      onChange={handleNewPlotFormChange}
                      sx={{ borderRadius: 2 }}
                    >
                      <MenuItem value="">Select New Site</MenuItem>
                      {siteOptions.map((site) => (
                        <MenuItem key={site} value={site}>
                          {site}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.newSiteName && (
                      <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                        {errors.newSiteName}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    name="newPlotNo"
                    label="New Plot Number *"
                    value={newPlotForm.newPlotNo}
                    onChange={handleNewPlotFormChange}
                    placeholder="Enter new plot number"
                    error={!!errors.newPlotNo}
                    helperText={errors.newPlotNo}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Home color="action" />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    name="changeReason"
                    label="Reason for Plot Change *"
                    value={newPlotForm.changeReason}
                    onChange={handleNewPlotFormChange}
                    placeholder="Please specify the reason for changing the plot"
                    multiline
                    rows={3}
                    error={!!errors.changeReason}
                    helperText={errors.changeReason}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 3, gap: 2, borderTop: '1px solid #e0e0e0' }}>
          <Button
            onClick={handleCloseChangePlotDialog}
            variant="outlined"
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              px: 3
            }}
          >
            Cancel
          </Button>
          {/* {canWriteChangePlot && ( */}
          <Button
            onClick={handleConfirmChangePlot}
            color="primary"
            variant="contained"
            disabled={!newPlotForm.newSiteName || !newPlotForm.newPlotNo || !newPlotForm.changeReason || changeLoading}
            startIcon={<SwapHoriz />}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
            }}
          >
            {changeLoading ? 'Changing Plot...' : 'Change Plot'}
          </Button>
          {/* )} */}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ChangePlot;